import React, { useLayoutEffect } from 'react';
import { Link } from 'react-router-dom';

const About = ({ aboutData, subAboutData }) => {
    useLayoutEffect(() => {
        // Trigger animations for this section
        if (window.animationText) window.animationText();
        if (window.scrollingEffect) window.scrollingEffect();
        if (window.animateImgItem) window.animateImgItem();

        // Refresh ScrollTrigger as content might have changed
        if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
        }

        return () => {
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [aboutData, subAboutData]);

    return (
        <section id="about" className="section-about tf-spacing-2">
            <div className="about-top">
                <div className="tf-marquee">
                    <div className="marquee-wrapper">
                        <div className="initial-child-container">
                            {[...Array(20)].map((_, i) => (
                                <div className="big-text" key={i}>
                                    {subAboutData?.main_title || 'Software Development'}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="tf-container">
                <div className="about-inner flex g-30">
                    <div className="left">
                        <div className="wg-curve-text">
                            <div className="icon">
                                <i className="icon-arrow-up"></i>
                            </div>
                            <div className="text-rotate">
                                <svg width="270" height="270" viewBox="0 0 270 270" xmlns="http://www.w3.org/2000/svg">
                                    <defs>
                                        <path id="textPathCircle" d="M 135,135 m -110,0 a 110,110 0 1,1 220,0 a 110,110 0 1,1 -220,0" fill="none" />
                                    </defs>
                                    <text>
                                        <textPath href="#textPathCircle" startOffset="0" textLength="690" lengthAdjust="spacing">
                                            - Software - Solutions - Company&nbsp;
                                        </textPath>
                                    </text>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div className="right">
                        <div className="heading-section mb-30">
                            <div
                                className="sub-title body-2 fw-7 mb-17 title-animation"
                                dangerouslySetInnerHTML={{ __html: aboutData?.top_title || 'We Are WMK TECH Software Company' }}
                            />
                            <h2
                                className="title fw-6 title-animation"
                                dangerouslySetInnerHTML={{
                                    __html: aboutData?.main_title || `We develop high quality bespoke web and mobile applications for <span class="fw-3"> organizations, institutions, and SMEs</span>`
                                }}
                            />
                        </div>
                        <div className="section-content">
                            <div
                                className="desc mb-40 text-animation"
                                dangerouslySetInnerHTML={{
                                    __html: aboutData?.description || `<p class="lh-30">Our team is well-versed in software development and is ready to help develop the applications of your choice. We take responsibility for building custom software solutions that cater to the automation of your business processes and improve efficiency.</p>`
                                }}
                            />
                            <div className="tf-animate-3">
                                <Link to="/contact" className="tf-btn no-bg text-underline">
                                    <span>Contact us</span>
                                    <i className="icon-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;
